import React, {useState} from 'react'
import {Row, Col, FormGroup, Input} from "reactstrap";


// labels
import {LB_ASSIGN_HOURS, LB_HOUR, LB_LABEL_RESULT, LB_MINUTES} from "../i18n/i18n";

// utilerías
import {format24HourIn12Hours} from "../../util/DateTools";



/**
 * Componente para asignar la hora y los minutos a la etiqueta de horarios recurrentes
 * @param originalLabel
 * @param onTimeChange
 * @param onMinutesChange
 * @returns {JSX.Element}
 * @constructor
 */
const AssignScheduleTime = ({originalLabel = '', onTimeChange, onMinutesChange, onLabelChange}) => {
    const [time, setTime] = useState()
    const [minutes, setMinutes] = useState()
    const [label, setLabel] = useState(originalLabel)

    /**
     * Gestionar el cambio en las horas
     * @param e
     */
    const onChangeLocalTime = e => {
        const value = e.target.value
        const formatValue = format24HourIn12Hours(e.target.value)
        let newLabel = originalLabel.replace('{hour}', formatValue)

        if(minutes != null)
            newLabel = newLabel.replace('{minutes}', minutes)

        setTime( value )
        setLabel( newLabel )
        onTimeChange( value )
        onLabelChange( newLabel )
    }

    /**
     * Gestionar el cambio en los minutos
     * @param e
     */
    const onChangeLocalMinutes = e => {
        const value = e.target.value
        let newLabel = originalLabel.replace('{minutes}', value)

        if(time != null)
            newLabel = newLabel.replace('{hour}', format24HourIn12Hours(time))

        setMinutes( value )
        setLabel( newLabel )
        onMinutesChange( value )
        onLabelChange( newLabel )
    }


    return <>
        <h3>{LB_ASSIGN_HOURS}</h3>
        <br/>
            <Row>
                <Col md={{ size:'auto', offset:4}}>
                    <FormGroup>
                        <label>{LB_HOUR}</label>
                        <br/>
                        <Input
                            className={'input-continue'}
                            type={'time'}
                            value={time}
                            onChange={ onChangeLocalTime }
                        />
                    </FormGroup>
                </Col>
                <Col md={{ size:'auto', offset:1}}>
                    <FormGroup>
                        <label>{LB_MINUTES}</label>
                        <br/>
                        <Input
                            className={'input-continue'}
                            type={'number'}
                            value={minutes}
                            min={0}
                            max={60}
                            onChange={ onChangeLocalMinutes }
                        />
                    </FormGroup>
                </Col>
            </Row>
        <br/>
            <Row>
                <Col>
                    <strong>{LB_LABEL_RESULT}:</strong>
                    <br/>
                    { label }
                </Col>
            </Row>
        <br/>
        <br/>
    </>
}

export default  AssignScheduleTime